module.exports = __webpack_public_path__ + "img/Scryptum_mock.41ec76e0.png";